import moment from "moment";
import { Radio, Modal } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import chair from '../../../assets/images/common/chair.svg';
import RangePicker from '../../Common/DatePicker/RangePicker';
import person from '../../../assets/images/common/person.svg';
import { getSpaceAvailability } from '../HostDashboardActions';
import arrow from '../../../assets/images/common/black-arrow.svg';
import {getDatesBetween} from "../../../helper/RangePickerHelper";
import { TextField, DatePicker, Grid, Chip, Cell } from 'react-md';
import TimeRangePicker from '../../Common/TimePicker/TimeRangePicker';
import React, { useState, useCallback, memo, useEffect } from 'react';
import useWindowDimensions from '../../Common/Hooks/useWindowDimensions';
import SingleDatePicker from './../../Common/DatePicker/SingleDatePicker';
import {CALENDER_DATE_FORMAT, DATE_PICKER_DATE_FORMAT, IMAGES_BASE_URL} from '../../../settings';
import SeatingArrangementSelect from '../../Booking/SubComponent/SeatingArrangementSelect';
import { DAILY, BLOCK, HOURLY, DATE_FORMAT, DATE_FORMAT_REVERSE, TIME_FORMAT, WORK, MEET } from '../../Common/constants';
import {CREATE, EDIT, SEATING_ARRANGEMENT} from "../../Common/constants";
import { editReservationMergeSlot } from './../../../helper/createReservationModel';
import ReservationLoader from "../../Common/Loaders/ReservationLoader";

const CreateReservationMeetModal = memo(({
  setVisible,
  space,
  onProceed,
  selectedSpaceDetails,
  blockType,
  previousBookingData,
  selectedDateOnCalender,
  category
}) => {

  const { width } = useWindowDimensions();
  const dispatch = useDispatch();
  const DEFAULT_DATE = new Date();
  const dayBeforeToday = new Date(DEFAULT_DATE);
  dayBeforeToday.setDate(DEFAULT_DATE.getDate() - 1);
  const [slots, setSlots] = useState([]);
  const [timePickers, setTimePickers] = useState([{ beginTime: '3:00 am', endTime: '5:00 pm' }]);
  const [startDateState, setStartDateState] = useState(moment(previousBookingData?.startingDate || moment()).format(DATE_PICKER_DATE_FORMAT));
  const [availableSlots, setAvailableSlots] = useState(false);
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectedSingleDate, setSelectedSingleDate] = useState([]);
  const [duration, setDuration] = useState(1);
  const [datePickers, setDatePickers] = useState([`${moment().format('L')} - ${moment().format('L')}`]);
  const [range, setRange] = useState(duration);
  const [bookingDetails, setBookingDetails] = useState({});
  const [guestDetails, setGuestDetails] = useState({});
  // chargingTypes & paymentType need to react to late-arriving `space` prop (was static before)
  const [chargingTypes, setChargingTypes] = useState(space?.events?.[0]?.chargings || []);
  const [selectedChips, setSelectedChips] = useState([]);
  const [seatingSVG, setSeatingSVG] = useState();
  const [seatingText, setSeatingText] = useState();
  const [buttonDisplayStatus, setButtonDisplayStatus] = useState(false);
  const seatingArrangement = space?.events?.[0]?.seatArrangements || [];
  const [viewGuestCount, setViewGuestCount] = useState(1);
  const [maxGuest, setMaxGuest] = useState(space?.events?.[0]?.seatArrangements[0]?.max);
  const [paymentType, setPaymentType] = useState(chargingTypes?.[0]?.chargingType?.name);
  const [spaceBlockSlots, setSpaceBlockSlots] = useState([]);

  const availableDates = useSelector(state => state?.hostDashboard?.availability?.data || []);
  const selectedSpaceData = useSelector(state => state?.hostDashboard?.data?.selectedSpaceData || []);
  const events = selectedSpaceDetails?.events || {};
  let acceptableBookingTime = false;
  let minimumBookingPeriod = 1;

  if (events && events[0]?.chargings) {
    const hourlyCharging = events[0].chargings.find((charging) => charging?.chargingType?.name === HOURLY);
    if (hourlyCharging) {
      minimumBookingPeriod = hourlyCharging.minimumBookingPeriod || 1;
      acceptableBookingTime = hourlyCharging.acceptedHalfHourBooking || false;
    }
  }

  const isFetchingAvailableDates = useSelector(state => state?.hostDashboard?.availability?.fetching || []);

  // Fetch availability once we have space & paymentType (supports async space load)
  useEffect(() => {
    if (space && space.events && space.events.length > 0 && paymentType) {
      dispatch(
        getSpaceAvailability(
          { spaceId: space.id, eventTypeId: space.events[0].eventType.id, startDate: startAvailabilityDate, endDate: endAvailabilityDate },
          paymentType
        )
      );
    }
  }, [space, paymentType]);

  // Initialize charging types & payment type when space arrives (especially for CREATE flow)
  useEffect(() => {
    if (!space || !space.events || !space.events.length) return;
    const newChargingTypes = space.events[0]?.chargings || [];
    // Always update charging types when space changes
    setChargingTypes(newChargingTypes);
    if (blockType === EDIT && selectedSpaceData?.chargingType) {
      // Ensure selected charging type for edit
      setPaymentType(selectedSpaceData.chargingType);
      setChargingTypes(newChargingTypes.filter(ct => ct?.chargingType?.name === selectedSpaceData.chargingType));
    } else if (blockType === CREATE) {
      // For create, default to first charging type if paymentType not already set / changed
      if (!paymentType || !newChargingTypes.find(ct => ct?.chargingType?.name === paymentType)) {
        setPaymentType(newChargingTypes?.[0]?.chargingType?.name);
      }
    }
  }, [space, blockType, selectedSpaceData]);

  useEffect(() => {
    // Sync block slots whenever chargingTypes change OR paymentType changes
    if (blockType === EDIT && selectedSpaceData?.chargingType) {
      setPaymentType(selectedSpaceData.chargingType);
    }
    if (!chargingTypes || !chargingTypes.length) return;
    const blockSlots = chargingTypes.find(charging => charging.chargingType.name === BLOCK);
    if (blockSlots) {
      const availableBlocks = blockSlots?.pricingOptions;
      setSpaceBlockSlots(availableBlocks);
    }
  }, [chargingTypes, paymentType, blockType, selectedSpaceData]);

  useEffect(()=>{
    bookingDetails.title = previousBookingData?.title || "";
    bookingDetails.description = previousBookingData?.description || "";
    guestDetails.firstName = previousBookingData?.firstName;
    guestDetails.lastName = previousBookingData?.lastName || "";
    guestDetails.contact = previousBookingData?.contact || "";
    guestDetails.email = previousBookingData?.email || "";
    setViewGuestCount(previousBookingData?.guestCount || "");
    setSeatingText(previousBookingData?.seatingArrangement || SEATING_ARRANGEMENT);
    let seatingArrangementSVG = seatingArrangement[0]?.seatArrangement && seatingArrangement.filter(item => {
      if (item.seatArrangement.name === previousBookingData?.seatingArrangement) {
        return item;
      }
      })?.[0]?.seatArrangement?.icon || "";
    blockType === EDIT ? setSeatingSVG(IMAGES_BASE_URL + seatingArrangementSVG):setSeatingSVG("");
    seatingArrangement.map(item => {
      if(item?.seatArrangement?.name === previousBookingData?.seatingArrangement){
        handleMenuClick(item?.seatArrangement?.name,`${IMAGES_BASE_URL}${item.seatArrangement.icon}`)
      }
    });
    setPreviousDates()
  },[blockType, previousBookingData])

  const setPreviousDates = () =>{
    setBookingDate(moment(previousBookingData?.startingDate || moment()).format(DATE_PICKER_DATE_FORMAT))
    if(previousBookingData && previousBookingData.startingDate && previousBookingData.endingDate)
      setSelectedDate([
        getDatesBetween(
            moment(previousBookingData.startingDate, moment.defaultFormat).toDate(),
            moment(previousBookingData.endingDate, moment.defaultFormat).toDate()
        )
      ]);

    if(blockType === CREATE){
      setSelectedDate([
        getDatesBetween(
            moment(selectedDateOnCalender, moment.defaultFormat).toDate(),
            moment(selectedDateOnCalender, moment.defaultFormat).toDate()
        )
      ]);

      getSlotsForSelectedDate(moment(selectedDateOnCalender).format(DATE_PICKER_DATE_FORMAT));
      setStartDate(moment(selectedDateOnCalender).format(DATE_PICKER_DATE_FORMAT));
      setEndDate(moment(selectedDateOnCalender).format(DATE_PICKER_DATE_FORMAT));
      setStartDateState(moment(selectedDateOnCalender).format(DATE_PICKER_DATE_FORMAT));
    }
  }

  const [startDate, setStartDate] = useState(moment().format(DATE_PICKER_DATE_FORMAT));
  const [endDate, setEndDate] = useState(moment().format(DATE_PICKER_DATE_FORMAT));
  const startAvailabilityDate = moment().format(DATE_FORMAT_REVERSE);
  const endAvailabilityDate = moment().add(3, 'months').format(DATE_FORMAT_REVERSE);

  // (Redundant fetch removed; consolidated into unified fetch effect above)

  //set filterd time for initial date
  useEffect(() => {
    getSlotsForSelectedDate(moment(startDateState).format(DATE_PICKER_DATE_FORMAT))
  }, [availableDates]);

  //Filter time/block for hourly and block pricing options
  const findAvailableDate = (date) => {
    return availableDates.find(availableDate => {
      const [selecteAvailableDate] = Object.keys(availableDate);
      if (availableDate[`${moment(date).format(DATE_FORMAT)}T00:00:00.000+0000`] &&
        `${moment(date).format(DATE_FORMAT)}T00:00:00.000+0000` === selecteAvailableDate)
        return availableDate[selecteAvailableDate];
    });
  }

  const setBlocksForSelectedDate = (availableBlockSlots) => {
    const filteredSlotsForBlock = [];
    if (availableBlockSlots && availableBlockSlots.length > 0) {
      availableBlockSlots.forEach(blockSlot => {
        const slotTime = blockSlot.length && blockSlot.split('-');
        slotTime && slotTime.length > 0 && filteredSlotsForBlock.push({
          startTime: moment(slotTime[0], TIME_FORMAT).format(TIME_FORMAT),
          endTime: moment(slotTime[1], TIME_FORMAT).format(TIME_FORMAT),
          name: spaceBlockSlots?.find(item => item.startTime == moment(slotTime[0], TIME_FORMAT).format(TIME_FORMAT))?.name
        }
        )
      })
    }
    return filteredSlotsForBlock;
  }

  const getSlotsForSelectedDate = (date) => {
    if (date) {
      const available = findAvailableDate(date);

      if (available && available[`${moment(date).format(DATE_FORMAT)}T00:00:00.000+0000`]) {
        if(blockType === EDIT && paymentType === HOURLY){

          if(available[`${moment(date).format(DATE_FORMAT)}T00:00:00.000+0000`]?.status && available[`${moment(date).format(DATE_FORMAT)}T00:00:00.000+0000`].slots){
            setAvailableSlots(editReservationMergeSlot({startTime: previousBookingData?.startTime, endTime:  previousBookingData?.endTime}, available[`${moment(date).format(DATE_FORMAT)}T00:00:00.000+0000`].slots));
        } else {
            setAvailableSlots([{startTime: previousBookingData?.startTime, endTime:  previousBookingData?.endTime}]);}

        }else{
          setAvailableSlots(available[`${moment(date).format(DATE_FORMAT)}T00:00:00.000+0000`].slots);
        }

        if (paymentType === BLOCK) {
          const availableBlockSlots = available[`${moment(date).format(DATE_FORMAT)}T00:00:00.000+0000`]?.slots || [];
          const filteredSlotsForBlock = setBlocksForSelectedDate(availableBlockSlots);

          if (blockType === EDIT && moment(previousBookingData.startingDate, DATE_FORMAT).isSame(moment(date, DATE_PICKER_DATE_FORMAT))) {
            const previousSelectedSlots = previousBookingData?.blocks;
            if (Array.isArray(previousSelectedSlots)) {
              setSelectedChips([...previousSelectedSlots]);

              if (filteredSlotsForBlock.length > 0) {
                // merge + deduplicate
                const merged = [
                  ...filteredSlotsForBlock,
                  ...previousSelectedSlots.filter(
                    (ps) => !filteredSlotsForBlock.some((fs) => fs.startTime === ps.startTime && fs.endTime === ps.endTime)
                  ),
                ];
                setSlots(merged);
              } else {
                // do not overwrite with only preselected
                setSlots((prev) => [...prev]);
              }
            }
          } else {
            availableBlockSlots.length > 0 && setSlots(filteredSlotsForBlock);
          }
        }

      }
    }
  }

  const handleMenuClick = (name, svg) => {
    setSeatingSVG && setSeatingSVG(svg);
    setSeatingText && setSeatingText(name);

    setMaxGuest(seatingArrangement[0]?.seatArrangement && seatingArrangement.filter(item => {
      if (item.seatArrangement.name === name) {
        return item;
      }
    })[0].min);

    if(blockType === CREATE) {
      setViewGuestCount(1);
    }
  };

  const setBookingDate = date => {
    getSlotsForSelectedDate(date);
    setStartDate(moment(date).format(DATE_PICKER_DATE_FORMAT));
    setEndDate(moment(date).format(DATE_PICKER_DATE_FORMAT));
    setStartDateState(date);
    setSelectedDate([date]);
  };

  const handleGuestChange = value => {
    if (value > 0 && value <= maxGuest) {
      setViewGuestCount(value);
    } else if (value > maxGuest){
      setViewGuestCount(maxGuest)
    }
  };

  let submitStartDate = startDate;
  let submitEndDate = endDate;

  const handleOnProceed = () => {
    const dates = [].concat(...selectedDate);
    let chargingType;
    let payload  = {}
    const selectedSeating = category === "Meet" ? seatingArrangement.find(seating => seating.seatArrangement?.name === seatingText)?.seatArrangement : '';

  

    switch (paymentType) {
      case DAILY:
        setStartDate(dates[0]);
        setEndDate(dates[dates.length - 1]);
        submitStartDate = dates[0];
        submitEndDate = dates[dates.length - 1];
        chargingType = events?.[0]?.chargings?.find(item => item.chargingType.name === DAILY);
        break;
      case HOURLY:
        setEndDate(dates[0]);
        setStartDate(dates[0]);
        chargingType = events?.[0]?.chargings?.find(item => item.chargingType.name === HOURLY);
        break;
      default:
        setEndDate(startDate);
        break;
    }

    if (paymentType === BLOCK) {

      const selectedBlocks = selectedChips.map(chip => {
        return {
          name: chip.name,
          startTime: chip.startTime,
          endTime: chip.endTime
        }
      })

      payload = {
        id: selectedSpaceData?.id,
        space: space.id,
        event: {
          eventType: space.events[0]?.eventType?.name,
          eventTypeId: space.events[0]?.eventType?.id,
          guestCount: viewGuestCount,
          startDate: startDate ? moment(startDate, DATE_PICKER_DATE_FORMAT).format(CALENDER_DATE_FORMAT) : '',
          endDate: endDate ? moment(startDate, DATE_PICKER_DATE_FORMAT).format(CALENDER_DATE_FORMAT) : '',
          chargingTypeId: chargingTypes.find(item => item.chargingType.name === paymentType).chargingType.id,
          seatArrangement: {
            name: selectedSeating?.name,
            description: selectedSeating?.description,
            icon: selectedSeating?.icon
          },
          blocks: selectedBlocks,
        },
        details: {
          title: bookingDetails.title,
          description: bookingDetails.description
        },
        guest: {
          firstName: guestDetails.firstName,
          lastName: guestDetails.lastName,
          contactNumber: guestDetails.contact,
          email: guestDetails.email
        }
      }
    } else if (paymentType === HOURLY) {
      payload = {
        id: selectedSpaceData?.id,
        space: space.id,
        event: {
          eventType: space.events?.[0]?.eventType?.name || "",
          eventTypeId: space.events?.[0]?.eventType?.id || "",
          guestCount: viewGuestCount,
          startDate: moment(submitStartDate, DATE_PICKER_DATE_FORMAT).format(CALENDER_DATE_FORMAT) ||  moment(startDate, DATE_PICKER_DATE_FORMAT).format(CALENDER_DATE_FORMAT),
          endDate: moment(submitEndDate, DATE_PICKER_DATE_FORMAT).format(CALENDER_DATE_FORMAT) ||  moment(endDate, DATE_PICKER_DATE_FORMAT).format(CALENDER_DATE_FORMAT),
          chargingTypeId: chargingTypes?.find(item => item?.chargingType?.name === paymentType)?.chargingType?.id,
          seatArrangement: {
            name: selectedSeating?.name,
            description: selectedSeating?.description,
            icon: selectedSeating?.icon
          },
          blocks: [
            {
              name: chargingType?.pricingOptions?.[0].name,
              startTime: timePickers?.[0]?.beginTime,
              endTime: timePickers?.[0]?.endTime
            }
          ],
        },
        details: {
          title: bookingDetails.title,
          description: bookingDetails.description
        },
        guest: {
          firstName: guestDetails.firstName,
          lastName: guestDetails.lastName,
          contactNumber: guestDetails.contact,
          email: guestDetails.email
        }
      }
    } else {
      payload = {
        id: selectedSpaceData?.id,
        space: space.id,
        event: {
          eventType: space.events[0]?.eventType?.name,
          eventTypeId: space.events[0]?.eventType?.id,
          guestCount: viewGuestCount,
          startDate: moment(submitStartDate, DATE_PICKER_DATE_FORMAT).format(CALENDER_DATE_FORMAT),
          endDate: moment(submitEndDate, DATE_PICKER_DATE_FORMAT).format(CALENDER_DATE_FORMAT),
          chargingTypeId: chargingTypes.find(item => item.chargingType.name === paymentType).chargingType.id,
          blocks: [
            {
              name: chargingTypes?.find(chargingType => chargingType.chargingType.name === paymentType).pricingOptions?.[0]?.name || DAILY,
              startTime: chargingTypes?.find(chargingType => chargingType.chargingType.name === paymentType).pricingOptions?.[0]?.startTime || "",
              endTime:  chargingTypes?.find(chargingType => chargingType.chargingType.name === paymentType).pricingOptions?.[0]?.endTime || ''
            }
          ],
          seatArrangement: {
            name: selectedSeating ? selectedSeating?.name : '',
            description: selectedSeating ? selectedSeating?.description : '',
            icon: selectedSeating ? selectedSeating?.icon : ''
          }
        },
        details: {
          title: bookingDetails.title,
          description: bookingDetails.description
        },
        guest: {
          firstName: guestDetails.firstName,
          lastName: guestDetails.lastName,
          contactNumber: guestDetails.contact,
          email: guestDetails.email
        }
      }
    }
    onProceed(payload);
    setGuestDetails({
      firstName: '',
      lastName: '',
      contact: '',
      email: ''
    })
    setBookingDetails({
      title: '',
      description: ''
    })
    setSeatingText();
    setSeatingSVG();
    setTimePickers([{ beginTime: '3:00 am', endTime: '5:00 pm' }])
  };

  const chipColor = slot => {
    return selectedChips.includes(slot) && 'selected-chip';
  };

  const handleTimeChipClick = slot => {
    if (selectedChips.includes(slot)) {
      setSelectedChips(
        selectedChips.filter(function (value) {
          return value !== slot;
        })
      );
    } else {
      setSelectedChips([...selectedChips, slot]);
    }
  };

  const handleDateChange = (dateIndex, date) => {
    const filteredList = datePickers.map((other, index) => {
      if (index === dateIndex) {
        return date;
      } else {
        return other;
      }
    });
    setDatePickers(filteredList);
    const dates = [].concat(...selectedDate);

    setRange(dates.length);
  };

  const handleBookingDetailsOnChange = useCallback((name, value) => {
    setBookingDetails(b => {
      return { ...b, [name]: value };
    });
  }, []);

  const handleGuestDetailsOnChange = useCallback((name, value) => {
    setGuestDetails(b => {
      return { ...b, [name]: value };
    });
  }, []);

  const getDateClassName = date => {
    const calendarDate = moment(date).format('L');
    const today = moment().format('L');

    const isToday = calendarDate === today;
    if (isToday) {
      return 'current-date';
    }

    return null;
  };

  const handleBack = () => {
    setVisible(false);
  };

  const validateEmail = (email) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/.test(email);

  useEffect(()=>{
    if(!bookingDetails.title){
      setButtonDisplayStatus(true);
    }else if (paymentType === BLOCK && selectedChips.length === 0){
      setButtonDisplayStatus(true);
    }else if (!findAvailableDate(startDate)?.[`${moment(startDate).format(DATE_FORMAT)}T00:00:00.000+0000`]?.status && blockType === CREATE && paymentType !== DAILY){
      setButtonDisplayStatus(true);
    } else if(guestDetails.email.length > 0 && !validateEmail(guestDetails.email)){
      setButtonDisplayStatus(true);
    }else{
      setButtonDisplayStatus(false);
    }
  },[bookingDetails.title,seatingText,selectedChips,availableDates,startDate,guestDetails])

  return (
    <>
      <div className="fixed-header">
        <img src={arrow} alt="arrow" className="arrow-img" onClick={() => handleBack()} />
        <div className="text">{space.spaceName}</div>
      </div>
      <div className="content">
        <span className="modal-title">{blockType} reservation</span>
        <div className="radio-btn-wrapper input-margin-wrapper">
          <Radio.Group
            onChange={e => {
              setPaymentType(e.target.value);
            }}
            defaultValue={blockType !== EDIT ? chargingTypes.length ? chargingTypes[0].chargingType.name : 'Daily' : selectedSpaceData.chargingType || 'Daily'}
            buttonStyle="solid"
          >
            <div className="radio-btn-inner-wrapper">
              {chargingTypes?.map(type => (
                <Radio.Button value={type?.chargingType?.name}>{type?.chargingType?.name}</Radio.Button>
              ))}
            </div>
          </Radio.Group>
        </div>
        {category?.toLowerCase() === MEET && seatingArrangement?.length > 1 && (
          <div className="seating-wrapper input-margin-wrapper">
            <img src={chair} className="img" alt="chair" />
            <SeatingArrangementSelect
              seatingArrangement={seatingArrangement}
              handleMenuClick={handleMenuClick}
              seatingSVG={seatingSVG}
              seatingText={seatingText}
            />
          </div>
        )}
        <TextField
          className="guest-input input-margin-wrapper"
          id="guest"
          min="1"
          leftIcon={<img src={person} className="img" alt="person" />}
          label="Guest"
          type="number"
          onChange={(value) => handleGuestChange(value)}
          value={viewGuestCount}
        />
        {availableDates.length > 0 ? (
        <div className="date-block-wrapper">
          {paymentType != DAILY ? (
            <>
              <div className="minus-btn-wrapper">
                <SingleDatePicker
                  selectedDate={startDateState}
                  getDateClassName={getDateClassName}
                  label={''}
                  minDate={dayBeforeToday}
                  onChange={setBookingDate}
                  availableDates={availableDates}
                  value={startDate}
                  blockType={blockType}
                  setPreviousDates={setPreviousDates}
                  urlUpdate={false}
                />
              </div>
            </>
          ) :
            (datePickers.map((picker, index) => (
              <div className="minus-btn-wrapper input-margin-wrapper" key={index}>
                <RangePicker
                  className="date-select"
                  key={index}
                  index={index}
                  setDuration={setDuration}
                  setSelectedDate={setSelectedDate}
                  selectedDate={selectedDate}
                  handleDateChange={handleDateChange}
                  dateString={picker}
                  availableDates={availableDates}
                  formFrom={'EDIT_RESERVATION'}
                  blockType={blockType}
                  setPreviousDates={setPreviousDates}
                  urlUpdate={false}
                />
              </div>
            )))}
        </div>
        ): (<ReservationLoader />)}
          {paymentType == HOURLY &&
            timePickers.map((picker, index) => (
            <div className="input-margin-wrapper">
                <TimeRangePicker disable={!(availableSlots?.length > 0)} key={index} startLimit={previousBookingData?.startTime || '7:00 am'} endLimit={previousBookingData?.endTime||'8:00 am'} timeRangeType={blockType} pickers={timePickers} setTimePicker={setTimePickers} index={index} availableSlots={availableSlots} acceptableBookingTime={acceptableBookingTime} minimumBookingPeriod={minimumBookingPeriod}/>
            </div>
            ))}
            {!(availableSlots?.length > 0) && !(availableDates?.length > 0) && !(isFetchingAvailableDates) &&
              <p style={{color:"red"}}>Date is not available.</p>
            }
          <div className="available-slot-wrapper input-margin-wrapper">
            {paymentType == BLOCK && <div className="text-gray">Available blocks</div>}
            <div className="available-slot-inner-wrapper">
              {paymentType == BLOCK &&
                slots?.map((slot, index) =>
                  <Chip className={chipColor(slot)} onClick={() => handleTimeChipClick(slot, index)} label={`${slot.startTime} - ${slot.endTime}`} />
                )}
            </div>
        </div>
      </div>
      {((timePickers[0].beginTime && timePickers[0].endTime) || selectedChips.length) && (
        <>
          <div className="content custom-margin">
            <p className="sub-text">Reservation details</p>
            <TextField
              className="input-margin-wrapper"
              id="title"
              label="Title"
              lineDirection="center"
              required
              errorText="This field is required."
              onChange={value => handleBookingDetailsOnChange('title', value)}
              value={bookingDetails.title}
            />

            <TextField
              className="input-margin-wrapper description-wrapper"
              id="description"
              label="Description"
              lineDirection="right"
              rows={3}
              placeholder=""
              onChange={value => handleBookingDetailsOnChange('description', value)}
              value={bookingDetails.description}
            />
            <p className="sub-text">Guest Personal Details</p>
            <div className="name-wrap left-wrap">
              <TextField
                className="input-margin-wrapper"
                id="firstName"
                label="First Name"
                lineDirection="right"
                placeholder=""
                onChange={value => handleGuestDetailsOnChange('firstName', value)}
                value={guestDetails.firstName}
              />
            </div>
            <div className="name-wrap right-wrap">
              <TextField
                className="input-margin-wrapper"
                id="lastName"
                label="Last Name"
                lineDirection="right"
                placeholder=""
                onChange={value => handleGuestDetailsOnChange('lastName', value)}
                value={guestDetails.lastName}
              />
            </div>
            <TextField
              className="input-margin-wrapper"
              id="contact"
              label="Contact Number"
              lineDirection="right"
              placeholder=""
              onChange={value => handleGuestDetailsOnChange('contact', value)}
              value={guestDetails.contact}
            />
            <TextField
              className="input-margin-wrapper"
              id="email"
              label="Email"
              typr='email'
              lineDirection="right"
              placeholder=""
              onChange={value => handleGuestDetailsOnChange('email', value)}
              value={guestDetails.email}
            />
          </div>
          <div className="footer">
            <button className="btn-yellow btn-reservation" swapTheming disabled={buttonDisplayStatus} onClick={handleOnProceed}>{blockType} reservation</button>
          </div>
        </>
      )}
      </>
  )
})

export default CreateReservationMeetModal;
